import Grid from '@mui/material/Grid';
import SearchBar from "components/UI/Search";
import React from "react";

interface Props {
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    placeHolder: string;
    padding?: string;
    useGrid?: boolean;
}

const SearchComponent = ({searchTerm, setSearchTerm, placeHolder, padding, useGrid = true}: Props) => {
    const searchBar = (
        <SearchBar
            placeholder={placeHolder}
            searchValue={searchTerm}
            onSearch={(searchText: string) => {
                setSearchTerm(searchText);
            }}
            containerWidth='100%'
        />
    );

    if (!useGrid) {
        return searchBar;
    }

    return (
        <Grid size={{ xs: 12, sm: 4, md: 3 }} style={{ padding }}>
            {searchBar}
        </Grid>
    );
}

export default React.memo(SearchComponent);